import React, { Fragment, useEffect, useState } from "react";
import { createOrderAPI, getOrdersAPI } from "../api-services/order.api";
import useChatStore from "../store/useChatStore";
import { API_URL } from "../api-services/Environment";

const OrderListPage = () => {
  const {
    setCurrentScreen,
    isFetched,
    setIsFetched,
    setCreatedOrderInfo,
    inputValue,
    setInputValue,
    chatbotTheme,
  } = useChatStore();

  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const shopUrl = window.location.href;
  const domain = new URL(shopUrl).host;

  const fetchOrders = () => {
    getOrders();
  };

  useEffect(() => {
    if (!isFetched) {
      setIsLoading(false);
      setOrders([]);
    }
    if (isFetched) {
      setIsLoading(true);
      fetchOrders();
    }
    if (orders?.length > 0) {
      setIsLoading(false);
    }
    setIsLoading(true);
  }, [isFetched]);

  const validateInput = () => {
    if (!inputValue) {
      return "This field is required.";
    }
    const emailRegex = /\S+@\S+\.\S+/;
    const phoneRegex = /^\d{10}$/;

    if (!emailRegex.test(inputValue) && !phoneRegex.test(inputValue)) {
      return "Please enter a valid email or phone number.";
    }

    return "";
  };

  const handleButtonClick = () => {
    const validationError = validateInput();
    if (validationError) {
      setError(validationError);
    } else {
      setError("");
      setIsFetched(true);
    }
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    setError("");
  };

  function formatPrice(value) {
    return parseFloat(value).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  const getOrders = () => {
    const params = {
      shop: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
      email: inputValue,
    };

    try {
      getOrdersAPI(params).then((res) => {
        setOrders(res?.payload?.orders);
        setIsLoading(false);
      });
    } catch {}
  };

  const handleSendMessage = async (orderInfo, product) => {
    const params = {
      shop: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
    };

    const orderPayload = {
      orderId: orderInfo.orderId.toString(),
      orderName: orderInfo.orderName,
      purchaseDate: orderInfo.purchaseDate,
      totalAmount: orderInfo.totalAmount,
      tax: orderInfo.tax,
      subTotal: orderInfo.subTotal,
      currency: orderInfo.currency,
      billingAddress: orderInfo.billingAddress,
      customerInfo: orderInfo.customerInfo,
      product: {
        productId: product.productId.toString(),
        name: product.name,
        price: product.price,
        quantity: product.quantity,
        image: product.image,
      },
    };

    createOrderAPI(params, orderPayload).then((res) => {
      if (res.status === 201) {
        const orderJsonPromise = res.json();
        orderJsonPromise.then((orderResp) => {
          setCreatedOrderInfo(orderResp.order);
          // getChatHistoryAPI({ customerUuid: orderResp.order.customerUuid }).then((historyResp) => {
          //   const conversationPayload = {
          //     conversationUuid: historyResp.payload.result.length > 0 ? historyResp.payload.conversationUuid : null,
          //     customerUuid: orderResp.order.customerUuid,
          //     messageType: "card",
          //     payload: product
          //   }
          setCurrentScreen("chat");
          // createConversationAPI(conversationPayload).then((conversationResp) => {
          //   if (conversationResp.status === 201) {
          //     setCurrentScreen('chat');
          //   }
          // })
          // })
        });
      }
    });
  };

  const renderEmailContainer = () => {
    return (
      <div className="login-page">
        <h2>Welcome</h2>
        <p style={{ marginBottom: "20px" }}>
          Please add your email or phone number to get your orders!
        </p>

        <input
          type="email"
          placeholder="Enter your email or phone number"
          value={inputValue}
          onChange={handleChange}
          className="form-input"
          style={{ marginBottom: 0 }}
        />
        {error && (
          <p style={{ color: "#ff4c4c", marginTop: "5px", textAlign: "start" }}>
            {error}
          </p>
        )}

        <button
          onClick={handleButtonClick}
          className={`form-button`}
          style={{ backgroundColor: chatbotTheme }}
        >
          <span className="button-text">Fetch Orders</span>
        </button>
      </div>
    );
  };

  const renderOrderList = () => {
    return (
      <div className="order-page">
        <label style={{ fontSize: 18, fontWeight: 600 }}>Your Orders</label>
        {isLoading && (
          <div className="loader-overlay">
            <img
              src={`${API_URL}common/gif/loader.gif.gif`}
              alt="loader"
              style={{ width: 80, height: 80 }}
            />
          </div>
        )}
        {orders?.map((order) => (
          <div key={order.orderId} className="orderdetails">
            <p>Order Id: {order.orderName}</p>
            <p>Order Date: {new Date(order.purchaseDate).toDateString()}</p>
            <p>Select the product to know more about it</p>
            {order.products.map((product) => (
              <div key={product.productId} className="product-card">
                <div>
                  <img
                    src={product.image}
                    alt="Product"
                    className="product-img"
                  />
                </div>
                <div className="carddetails">
                  <label className="productname">{product.name}</label>
                  <label className="productdtl">
                    price: {order.currency === "INR" ? "₹" : "$"}
                    {formatPrice(product.price)}
                  </label>
                  <div className="btn-qty">
                    <label className="productdtl">
                      qty: {product.quantity}
                    </label>
                    <button
                      type="button"
                      onClick={() => handleSendMessage(order, product)}
                      style={{ backgroundColor: chatbotTheme }}
                    >
                      Get Help
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
        {!isLoading && orders?.length === 0 && (
          <div className="no-order-div">No Orders Found</div>
        )}
      </div>
    );
  };

  return (
    <Fragment>
      {!isFetched ? renderEmailContainer() : renderOrderList()}
    </Fragment>
  );
};

export default OrderListPage;
